export default __webpack_public_path__ + "static/media/banner 1.7ff4778a.png";